// extracted by mini-css-extract-plugin
export var csatScore = "_lh-5";
export var header = "_lh-1";
export var panelWrapper = "_lh-2";
export var postPreview = "_lh-3";
export var rightContent = "_lh-0";
export var wrappingText = "_lh-4";